import { UserRole } from "../helpers/authHelper";

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-default";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "en";
export const localeOptions = [
  { id: "en", name: "English - LTR", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
  { id: "enrtl", name: "English - RTL", direction: "rtl" },
];

export const application = [
  { id: "ac-asdc-asdcsd-vsdv", name: "India Today App" },
  { id: "ac-asdc-asdcsd-vsdv1", name: "Testing App" },
  { id: "ac-asdc-asdcsd-vsdv3", name: "Public App" },
];

export const voiceType = [
  { key: "male", label: "Male", value: "male" },
  { key: "female", label: "Female", value: "female" },
];
export const vitraSupportedLanguages = [
  { key: "en", label: "English", value: "english" },
  { key: "es", label: "Spanish", value: "spanish" },
  { key: "ja", label: "Japanese", value: "japanese" },
  { key: "ka", label: "Kannada", value: "kannada" },
  { key: "hi", label: "Hindi", value: "hindi" },
  { key: "ta", label: "Tamil", value: "tamil" },
];

export const firebaseConfig = {
  apiKey: "AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg",
  authDomain: "gogo-react-login.firebaseapp1.com",
  databaseURL: "https://gogo-react-login.firebaseio1.com",
  projectId: "gogo-react-login",
  storageBucket: "gogo-react-login.appspot1.com",
  messagingSenderId: "216495999563",
};

export const adminRoot = "/app";
export const buyUrl = "https://1.envato.market/k4z0";
export const searchPath = `${adminRoot}/#`;
export const servicePath = "https://api.coloredstrategies.com";

export const currentUser = {
  id: 1,
  title: "Sarah Kortney",
  img: "/assets/img/profiles/l-1.jpg",
  date: "Last seen today 15:24",
  role: UserRole.Admin,
};

export const themeColorStorageKey = "__theme_selected_color";
export const isMultiColorActive = false;
export const defaultColor = "light.purplemonster";
export const isDarkSwitchActive = false;
export const defaultDirection = "ltr";
export const themeRadiusStorageKey = "__theme_radius";
export const isAuthGuardActive = true;
export const colors = [
  "bluenavy",
  "blueyale",
  "blueolympic",
  "greenmoss",
  "greenlime",
  "purplemonster",
  "orangecarrot",
  "redruby",
  "yellowgranola",
  "greysteel",
];
